import Gallery, { GalleryFillRow } from "components/Media/Gallery";

import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";

const AcceptanceLetterMain = (props: { gallery: any[] }) => {
  return (
    <>
      <ReplicaSpacer />
      <Gallery
        images={props.gallery}
        imagesPerRow={7}
        imageOptions={[{ index: 1, aspectRatio: 2 }]}
        imageMaxHeight="250px"
        fillRowAt={GalleryFillRow.start}
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        This authentic replica features a real wax seal, stamped with the
        Hogwarts crest. I carefully recreated the crest from the original prop
        and had a custom stamp made so I could reproduce the seal exactly as
        seen on screen. To make the replica more interactive, I devised a way to
        appear as though the envelope is sealed, while still allowing it to be
        opened and the contents removed. Inside, you’ll find two sheets written
        in emerald-green ink: the Hogwarts letter and the list of required books
        and equipment for first-year students. I noticed that later versions of
        this letter are (seemingly) typed on a typewriter rather than written by
        hand, but this version faithfully matches the handwritten letter as seen
        on screen.
      </ReplicaParagraph>
    </>
  );
};

export default AcceptanceLetterMain;
